import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { FaCamera } from 'react-icons/fa';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';

export const BrandMappingFavIconComponent = ({
  selectedBrand, index, openConfirmationLogo, getIsFavRecordDeletable, selectedFavIcon, changeFavImage,
  faviconSize, onFormFavItemChange, logoBackground, handleOpen, deleteselectedFavIcon, handleClose, itemIndex
}: any) => {

  return (
    <>
      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>
        <div className=' py-4'>
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <div>
              <InputLabelContainer label="Pictures" />
              <img
                src={selectedFavIcon?.Url}
                className="w-12 h-12"
              />
              <div
                onClick={() => changeFavImage(
                  index,
                  'Url',
                  'image',
                  selectedBrand,
                  itemIndex
                )}
              >
                <FaCamera className=' text-2xl text-skin-ouprimary' />
              </div>
            </div>
            <InputContainer
              label="Size"
              labelField="Description"
              list={faviconSize}
              onValueChange={(event: any, newValue: any) => {
                onFormFavItemChange({
                  value: event.target.value,
                  field: 'Size',
                  idx: index,
                  cardValue: selectedBrand,
                  idx1: itemIndex
                });
              }}
              optionName='Choose Size'
              type="select"
              value={selectedFavIcon?.Size}
              valueField="Description"
            />
            <InputContainer
              label="Background"
              labelField="Description"
              list={logoBackground}
              onValueChange={(event: any, newValue: any) => {
                onFormFavItemChange({
                  value: event.target.value,
                  field: 'Background',
                  idx: index,
                  cardValue: selectedBrand,
                  idx1: itemIndex
                });
              }}
              optionName='Choose Background'
              type="select"
              value={selectedFavIcon?.Background}
              valueField="Description"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default BrandMappingFavIconComponent;
